import { useContext } from 'react';

import { UndoRedoContext } from './undo-redo-context';

export const useUndoRedo = () => {
  const context = useContext(UndoRedoContext);

  if (context === undefined) {
    throw new Error('useUndoRedo must be used within an UndoRedoProvider');
  }

  return context;
};
